import { createBrowserHistory } from 'history';

import { BASE_PATH } from 'js/config/routes';

const history = createBrowserHistory({ basename: BASE_PATH });

export const getHistory = () => history;
